import { render, staticRenderFns } from "./preview-file-action.vue?vue&type=template&id=44f396b2&"
import script from "./preview-file-action.vue?vue&type=script&lang=js&"
export * from "./preview-file-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports